// Two tiny presentational rows shown under chart cards.
// - AvgRow: single summary line at the bottom of a card ("average X: Y").
// - BarValueRow: numbers aligned under each bar of a chart, always visible.

export function AvgRow({ label, value, color }) {
  const shown = value == null ? "0" : Math.round(value).toString();
  return (
    <div className="mt-3 pt-3 border-t border-neutral-100 text-right text-xs" dir="rtl">
      <span className="text-neutral-500">{label}: </span>
      <span className="font-bold num" style={{ color }}>{shown}</span>
    </div>
  );
}

// Row of values aligned under each bar of the chart (always visible — no hover needed)
export function BarValueRow({ series, valueKey, color = "#F97316", formatter, testid, compact, tiny }) {
  if (!series || series.length === 0) return null;
  const isDense = compact || series.length >= 10;
  // `tiny` — half-size text for year view where 12 monthly bars squeeze the row.
  const sizeCls = tiny ? "text-[6px]" : (isDense ? "text-[9px]" : "text-[11px]");
  return (
    <div
      className="mt-1 grid gap-0"
      style={{ gridTemplateColumns: `repeat(${series.length}, minmax(0, 1fr))`, paddingRight: 22, paddingLeft: 22 }}
      dir="rtl"
      data-testid={testid}
    >
      {series.map((s, i) => {
        const raw = s[valueKey];
        // Plain integer, NO thousands separator — saves space and shows every digit
        const shown = raw == null ? "0" : (formatter ? formatter(raw) : Math.round(raw).toString());
        return (
          <div key={i} className="text-center overflow-hidden">
            <div
              className={`font-bold num whitespace-nowrap ${sizeCls}`}
              style={{ color }}
            >{shown}</div>
          </div>
        );
      })}
    </div>
  );
}
